import React from 'react';

import { LatencyCard, fmtNum } from './LatencyCard';
import type { ThroughputResponse } from '../../../../../api';

type Props = {
  data?: ThroughputResponse | null;
  loading?: boolean;
};

// Average RPS is fractional (events / window seconds); keep two decimals rather
// than rounding sub-1 rates to 0 like fmtNum would.
const fmtRps = (v: number | null | undefined): string =>
  v === null || v === undefined
    ? '—'
    : v.toLocaleString(undefined, { maximumFractionDigits: 2 });

export const ThroughputCard: React.FC<Props> = ({ data, loading }) => {
  const items = data?.items ?? [];

  return (
    <LatencyCard
      title="Throughput"
      subtitle="request rate (req/s) by metric type"
      loading={loading}
      isEmpty={items.length === 0}
    >
      <div className="h-full overflow-auto">
        <table className="w-full text-small text-left">
          <thead className="text-secondary sticky top-0 bg-white">
            <tr className="border-b">
              <th className="py-2 pr-3 font-medium">Type</th>
              <th className="py-2 pr-3 font-medium text-right">Events</th>
              <th className="py-2 pr-3 font-medium text-right">Avg req/s</th>
              <th className="py-2 pr-0 font-medium text-right">Peak req/s</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={`${item.metric_type}-${index}`}
                className="border-b last:border-0"
              >
                <td className="py-2 pr-3">{item.metric_type}</td>
                <td className="py-2 pr-3 text-right">
                  {fmtNum(item.total_events)}
                </td>
                <td className="py-2 pr-3 text-right">{fmtRps(item.avg_rps)}</td>
                <td className="py-2 pr-0 text-right">{fmtNum(item.peak_rps)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </LatencyCard>
  );
};
